﻿import Layout from "./AdminLayout.vue";
import Index from "./Index.vue";

export default [
    {
        path: "/",
        component: Layout,
        children: [
            { path: "/", component: Index }
        ]
    }
]